export const restMilliSeconds = (time: string) => {
    if (!time) return 0
    const deadline = Date.parse(time);
    const today = Date.parse(new Date().toISOString());
    const diff = deadline - today;
    if (diff >= 0) {
        return diff
    } else {
        return 0
    }
}